import { hasPermission } from '@crm/shared'
import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { useState } from 'react'
import { Link } from '@tanstack/react-router'
import { useCreateClient } from '@/features/clients/api'
import { ClientForm } from '@/features/clients/client-form'
import { ApiClientError } from '@/lib/api'
import { fetchMe } from '@/lib/auth-query'

export const Route = createFileRoute('/_app/clients/new')({
  beforeLoad: async ({ context }) => {
    const me = await fetchMe(context.queryClient)
    if (me && !hasPermission(me.user.role, 'clients:create')) {
      throw redirect({ to: '/clients', search: {} })
    }
  },
  component: NewClientPage,
})

function NewClientPage() {
  const navigate = useNavigate()
  const create = useCreateClient()
  const [error, setError] = useState<string | null>(null)

  return (
    <div className="mx-auto max-w-5xl space-y-4">
      <div>
        <Link
          to="/clients"
          search={{}}
          className="inline-flex items-center gap-1 text-sm text-[var(--color-muted-foreground)] hover:underline"
        >
          <ArrowLeft className="h-3.5 w-3.5" />
          Back to clients
        </Link>
        <h1 className="mt-1 text-2xl font-semibold">Add client</h1>
      </div>

      <ClientForm
        submitLabel="Create client"
        loading={create.isPending}
        error={error}
        onCancel={() => navigate({ to: '/clients', search: {} })}
        onSubmit={(values) => {
          setError(null)
          create.mutate(values, {
            onSuccess: (data) =>
              navigate({ to: '/clients/$clientId', params: { clientId: data.client.id } }),
            onError: (e) =>
              setError(e instanceof ApiClientError ? e.message : 'Could not create the client'),
          })
        }}
      />
    </div>
  )
}
